exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* UU5.Forms.Text */\n.uu5-forms-number {\n  margin-top: 0.1em;\n  margin-bottom: 1em;\n}\n.uu5-forms-number:after {\n  display: block;\n  position: relative;\n  content: '';\n  clear: both;\n}\n.uu5-forms-input-button .uu5-forms-input-button-glyphicon {\n  position: relative;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/number.less
// module id = 327
// module chunks = 0